<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <p>
          The following are your current auto-generated email subscription
          settings. For each checked, you will no longer receive that email.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 custom-send">
        <span>"Do not send me the":</span>
      </div>
      <div class="col-md-4">
        <ul class="list-group">
          <li class="list-group-item">
            <input
              class="form-check-input me-1"
              type="checkbox"
              v-model="emailAfterClassRecap"
              @click="saveIt"
            />
            After Class Recap email
          </li>
          <li class="list-group-item">
            <input
              class="form-check-input me-1"
              type="checkbox"
              v-model="emailMidweekRecap"
              @click="saveIt"
            />
            Mid-week Recap email
          </li>
          <li class="list-group-item">
            <input
              class="form-check-input me-1"
              type="checkbox"
              v-model="emailWeeklyRecap"
              @click="saveIt"
            />
            Weekly Recap email
          </li>
        </ul>
      </div>
      <div class="col-md-4"></div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'user-subscribe',
  emits: ['saveIt'],
  computed: {
    ...mapGetters('users', ['user']),
    emailAfterClassRecap: {
      get() {
        let _data = false
        if (this.user) {
          _data = this.user.detail.isNoEmailAfterClassRecap
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'isNoEmailAfterClassRecap',
          value: value,
        })
      },
    },
    emailMidweekRecap: {
      get() {
        let _data = false
        if (this.user) {
          _data = this.user.detail.isNoEmailMidweekRecap
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'isNoEmailMidweekRecap',
          value: value,
        })
      },
    },
    emailWeeklyRecap: {
      get() {
        let _data = false
        if (this.user) {
          _data = this.user.detail.isNoEmailWeeklyRecap
        }
        return _data
      },
      set(value) {
        this.setUserData({
          name: 'isNoEmailWeeklyRecap',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('users', ['setUserData']),
    saveIt() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style scoped>
.custom-send {
  text-align: right;
}
</style>
